import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../ts/ServerApi/types/actionParams';

export class DeletePublishedConnectionsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deletePublishedConnections', { ids: ids });
  }
}
